var _rect, _rect2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabelSpiceBlends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 50,
    viewBox: "0 0 150 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 50,
    rx: 10,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 50,
    rx: 10,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 22,
    fill: "#000000",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "SPICE BLENDS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 38,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 400
  }, "(Flavor Profile)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelSpiceBlends);
export default __webpack_public_path__ + "static/media/label-spice-blends.2b447eb1375dd7f4c54f471dbc256967.svg";
export { ForwardRef as ReactComponent };